import { ProductIds } from '../commons/config'
import { adminHttpClient } from '../commons/adminHttpClient'

import { Permissions as Permission } from './permissions'
import { UserRoles as Role } from './userRoles'

export interface User {
  permissions: Permission[]
  roles: Role[]
  companyId: string
  companyName: string
  companyZipCode: string
  companyIsAle: boolean
  firstName: string
  lastName: string
  userId: string
  email: string
  workPhone: string
  receiveSms: boolean
  displayIntro: boolean
  companyUserId: string
  productId: number | ProductIds
  products: { id: number; name: string }[]
  canAccessCsiDashboard: boolean
  canAccessAdminDashboard: boolean
  canAccessDocReviewDashboard: boolean
  canAccessIchraDecisionTool: boolean
  viewInternalExpenses: boolean
  canDeactivateCompany: boolean
}

const getLoginUser = (): Promise<User> => {
  return adminHttpClient.get('/LoginUser')
}

export default getLoginUser
